export const environment = {
  production: true,
  apiUrl:'https://data.super-vise.it/api/',
  oscuraDati:true
};
